// extracted by mini-css-extract-plugin
export var loadingSpinner = "_12-0";
export var spinnerContainer = "_12-1";